import orgTree from './orgTree'
import company from './company'
import department from './department'
import project from './project'
import role from './role.js'
import roleTree from './roleTree/roleTree'
import roleHierarchy from './roleHierarchy'
import orgRole from './orgRole'
import user from './user'
import userRole from './userRole'
import permission from './permission'
import permissionMenu from './menu'
import permissionGroup from "@/api/organization/permissionGroup";
import userGroup from './userGroup'
import userGroupRole from './userGroupRole'
import userGroupUser from './userGroupUser'
import rolePermission from './rolePermission'
import roleRelation from './roleRelation'
import employee from './employee'
import qualificationRole from './qualificationRole'
import person from './person'
import qualification from "./qualification";
import position from "./position";
import positionRole from "./positionRole";
import positionGrade from "./positionGrade";
import positionGradeRole from "./positionGradeRole";
import orgPosition from "./orgPosition";
import userPerson from "./userPerson";
import menuPermission from "@/api/organization/menuPermission";
import employeePosition from "@/api/organization/employeePosition";
import personQualification from "@/api/organization/personQualification"
import operationPersonReport from "@/api/organization/operation-person-report";

const OrganizationServer = {
    orgTree: orgTree,
    company: company,
    department: department,
    project: project,
    role: role,
    roleTree: roleTree,
    roleHierarchy: roleHierarchy,
    orgRole: orgRole,
    user: user,
    userRole: userRole,
    userGroup: userGroup,
    userGroupRole: userGroupRole,
    userGroupUser: userGroupUser,
    rolePermission: rolePermission,
    roleRelation: roleRelation,
    employee: employee,
    position: position,
    positionRole: positionRole,
    positionGrade: positionGrade,
    positionGradeRole: positionGradeRole,
    qualification: qualification,
    qualificationRole: qualificationRole,
    person: person,
    permission: permission,
    permissionMenu: permissionMenu,
    permissionGroup: permissionGroup,
    menuPermission: menuPermission,
    orgPosition: orgPosition,
    userPerson: userPerson,
    employeePosition: employeePosition,
    personQualification: personQualification,
    operationPersonReport: operationPersonReport,
};

export default OrganizationServer;